import React, {memo} from "react";
import Grid from "@mui/material/Grid";
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import NavigationIcon from "@mui/icons-material/Navigation";
import {Box} from "@mui/material";
import Typography from "@mui/material/Typography";

const Head = memo((props) => {
    const data = props.data;
    return(
        <Box mb={5}>
            <Grid container alignItems="center">
                <Grid item xs={12} sm={6}>
                    <Typography variant={"h6"}>{data.title}</Typography>
                    <Typography style={{ color: '#8e8e8e'}}>{data.description}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} >
                    <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
                        <Link to={data.link}>
                            <Button variant="contained" color="default" >
                                <NavigationIcon />
                            </Button>
                        </Link>
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
})


export default Head;